<template>
  <div class="comp-out-call-kty call-mky-popup" v-if="visible">
    <!-- <jw-modal :width="450" class="call-mky-popup" title-align="start" :mask="false" :mask-closable="false" draggable v-model:visible="visible" :footer="false" unmount-on-close :closable="false"> -->
    <!-- <template #title> -->
    <div class="mky-header" @mousedown="handleRemove">
      <span class="del" @click="close"><icon-close v-if="ctiData.status !== 'CB_BUSY'" /></span>
      <jw-space>
        <template v-if="ctiData.agentNo">
          <label class="label">分机号码:</label>
          <span class="label-num">{{ ctiData.agentNo }} </span>
        </template>
        <label class="label">当前状态:</label>
        <!-- {{ ctiData.status }} -->
        <jw-tag size="mini" :color="classnameObj[ctiData.status]?.color || '#86909c'">{{ classnameObj[ctiData.status]?.label || '' }}</jw-tag>
        <!-- <jw-button v-if="!classnameObj[status]" type="primary" size="small" @click="registerPhone">注册</jw-button> -->
      </jw-space>
    </div>
    <!-- </template> -->
    <div class="mky-content">
      <p>
        <!-- <span v-if="ctiData.status">请先注册分机状态后再拨打</span> -->
        <span v-if="ctiData.status === 'CB_READY'">状态正常可拨打</span>
        <span v-else-if="ctiData.status === 'CB_CONNECT'">已连接，未登录，请关闭拨打电话弹窗，重新打开。</span>
        <span v-else-if="ctiData.status === 'CB_KICKOUT'">您的电话账号已在其他地方登陆，本地已强制下线！</span>
        <span v-else-if="classnameObj[ctiData.status]">{{ classnameObj[ctiData.status].label }}</span>
        <span v-else></span>
      </p>
      <div class="phone">{{ detail.callee || '暂无号码' }}</div>
      <div class="icon hangup" v-if="ctiData.status === 'CB_READY'" style="color: #00b42a">
        <jw-spin :loading="loading">
          <qf-icon-dial-phone @click="ctiFn.makecall()" />
        </jw-spin>
      </div>
      <div class="icon hangup" v-if="callStatus.includes(ctiData.status)" style="color: #f53f3f">
        <jw-spin :loading="loading">
          <qf-icon-dial-phone @click="ctiFn.hangUp()" />
        </jw-spin>
      </div>
      <div v-if="ctiData.status === 'CB_KICKOUT'">
        <jw-button type="primary" size="small" @click="reLogin">重新登陆</jw-button>
      </div>

      <!-- <div class="icon hangup" v-if="ctiData.status === 'CB_READY'" :style="{ color: status === 'Failed' ? '#00b42a' : classnameObj[status]?.color || '#86909c' }">
        <jw-spin :loading="loading">
          <qf-icon-dial-phone class="" @click="phoneHandle" />
        </jw-spin>
      </div> -->
    </div>
    <!-- </jw-modal> -->
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { publicService } from '@/api/public-service';
import { Message, Modal } from '@arco-design/web-vue';
import { reactive } from 'vue';
const visible = ref(false);
// const regStatus = ref(true);
const loading = ref(true);
const status = ref();
const detail = ref({});

const callStatus = ref(['CB_RINGING', 'CB_ANSWERING', 'CB_CUSTOMERRING', 'CB_REALTIME', 'CB_UNHOLD']);
const classnameObj = ref({
  CB_CONNECT: { class: 'hangup', icon: '', color: '#00b42a', label: '已连接' },
  CB_LOGIN: { class: 'hangup', icon: '', color: '#00b42a', label: '已登陆' },
  CB_READY: { class: 'hangup', icon: '', color: '#00b42a', label: '准备中' },
  CB_BUSY: { class: 'call', icon: '', color: '#f53f3f', label: '忙碌中' },
  CB_RINGING: { class: 'call', icon: '', color: '#f53f3f', label: '振铃中' },
  CB_ANSWERING: { class: 'call', icon: '', color: '#f53f3f', label: '振铃中' },
  CB_CUSTOMERRING: { class: 'call', icon: '', color: '#f53f3f', label: '被叫振铃' },
  CB_REALTIME: { class: 'call', icon: '', color: '#f53f3f', label: '通话中' },
  CB_UNHOLD: { class: 'call', icon: '', color: '#f53f3f', label: '通话中' },
  CB_HANGUP: { class: 'call', icon: '', color: '#f53f3f', label: '被叫挂机' },
  CB_KICKOUT: { class: 'call', icon: '', color: '#f53f3f', label: '已掉线' },
  CB_LOGOUT: { class: 'call', icon: '', color: '#00b42a', label: '登出' }
});

const stateEventListener = (data) => {
  console.log(5654, JSON.stringify(data));
  const origin = new Date().getTime();
  console.log(5654, origin);
  ctiData.status = data.event;
  switch (data.event) {
    case 'CB_CONNECT':
      if (data.data.code === 200) {
        window.sessionStorage['agentbar-request'] = data.data;
        //连接成功
        console.log(62000, 'data.data.message', data.data.message);
      }
      break;
    case 'CB_LOGIN':
      if (data.data.code === 200) {
        window.sessionStorage['state'] = data.event;
        console.log(62001, data.event, 'data.data.message', data.data.message);
        //登录成功
      } else {
        console.log(620011, data.event, data.data.message);
      }
      //异常code
      //403:登录失败，账号密码错误
      //405:绑定分机号异常
      //407:分机号异常

      break;
    case 'CB_LOGOUT':
      //登出成功
      window.sessionStorage['state'] = data.event;
      console.log(62002, data.event, 'CB_LOGOUT, data.data.message', data.data.message);
      break;
    case 'CB_READY':
      if (data.data.code === 200) {
        window.sessionStorage['state'] = data.event;
        //就绪成功
      } else {
        Message.warning({ content: data.data.message });
      }

      console.log(62003, data.event, 'data.data.message', data.data.message);
      //异常code
      //400:就绪失败
      //500:未找到分机绑定信息

      break;
    case 'CB_BUSY':
      if (data.data.code === 200) {
        window.sessionStorage['state'] = data.event;
        //成功置忙
      } else {
        console.log(data.data.message);
      }
      console.log(62004, data.event, 'data.data.message', data.data.message);

      //异常code
      //400:置忙失败

      break;
    case 'CB_REST':
      if (data.data.code === 200) {
        window.sessionStorage['state'] = data.event;
        //成功设置为小休
      } else {
        console.log(data.data.message);
      }

      console.log(62005, data.event, 'data.data.message', data.data.message);
      //异常code
      //400:小休失败

      break;
    case 'CB_PROGRESS':
      if (data.data.code === 200) {
        window.sessionStorage['state'] = data.event;
        //成功设置为后处理
      } else {
        console.log(data.data.message);
      }

      console.log(62006, data.event, 'data.data.message', data.data.message);
      //异常code
      //400:后处理失败

      break;
    case 'CB_RINGING':
      window.sessionStorage['state'] = data.event;
      //振铃事件
      console.log(data.data.data); //弹屏数据,具体参数如下
      //ani: "主叫号码"
      //area: "归属地"
      //areaCode: "归属地代号"
      //callId: "唯一标识"
      //currentTime: "当前时间"
      //dir: "呼叫方向INBOUND/OUTBOUND"
      //dnis: "被叫号码"
      //popScreenNo: "弹屏号码"
      //queueName: "队列名称"
      //userName: "坐席名称"
      //uuid: "同callid"
      console.log(62007, data.event, 'data.data.message', data.data.message);
      break;
    case 'CB_ANSWERING':
      window.sessionStorage['state'] = data.event;
      //接听事件
      break;
    case 'CB_REALTIME':
      //被叫应答
      console.log('-------> 被叫应答 <-------');
      break;
    case 'CB_HANGUP':
      //坐席挂机
      console.log('-------> 挂机放音 <-------');
      break;
    case 'CB_HOLD':
      window.sessionStorage['state'] = data.event;
      //保持
      break;
    case 'CB_UNHOLD':
      window.sessionStorage['state'] = data.event;
      //取消保持(取回)
      break;
    case 'CB_MAKECALL':
      //发起呼叫回调
      if (data.data.code !== 200) {
        //发起呼叫失败
      }
      break;
    case 'CB_LISTENCALL':
      //监听回调
      if (data.data.code !== 200) {
        console.log(data.data.message);
      }
      break;
    case 'CB_THREEWAY':
      //三方回调
      if (data.data.code === 200) {
        //success
      }
      break;
    case 'CB_KICKOUT':
      console.log('您的电话账号已在其他地方登陆，本地已强制下线！');
  }
};

const httpErrorCallback = (res) => {
  console.log(203, res);
};

const initConfig = reactive({
  inDeviceId: 'default',
  outDeviceId: 'default',
  baseUrl: 'https://tky.ketianyun.com',
  username: '',
  password: '',
  stateEventListener: stateEventListener,
  enableWebRTC: 'true',
  popScreen: null,
  iceCheckTimeout: 500,
  // webRTCAutoAnswer: localStorage.autoAnswer ? localStorage.autoAnswer === 'true' : false,
  debug: false,
  register_expire: 600,
  httpErrorCallback: httpErrorCallback,
  // autoLogin: true,
  autoReady: true
});
//
const ctiData = reactive({
  agentNo: '',
  status: ''
});

const webRTCCallback = {
  handle: (event, msg) => {
    if (event === 'check') {
      if (!msg) {
        //麦克风检测失败
        // micCheckModal.value = true;
      }
    }
    if (event === 'disconnected') {
      //webrtc电话掉线
      // this.logout();
      Modal.confirm({
        title: 'WebRTC掉线，分机已注销。是否重连？',
        okText: '重连',
        cancelText: '取消',
        onOk: () => {
          ctiFn.login();
        }
      });
    }
    if (event === 'invite') {
      //webrtc电话振铃
    }
    if (event === 'accepted') {
      //webrtc电话接听
    }
    if (event === 'terminated') {
      //webrtc电话结束
    }
  }
};
// 常用方法
const ctiFn = {
  login() {
    CtiAgentBar.login(ctiData.agentNo, initConfig.inDeviceId, initConfig.outDeviceId);
  },
  makecall() {
    //先设置为忙碌状态
    CtiAgentBar.busy();
    //发起外呼
    CtiAgentBar.makecall(detail.value?.callee);
    saveData();
  },
  // 挂机
  hangUp() {
    CtiAgentBar.hangup();
  }
};
// 重新登陆
const reLogin = async () => {
  CtiAgentBar.destroy();
  //  注册
  await ctiInit(detail.value);
};
// 初始化
const ctiInit = async (r) => {
  try {
    console.log(3813944, r, initConfig);
    const ctiRes = await CtiAgentBar.init(initConfig, null, webRTCCallback);
    if (ctiRes.code !== 200) {
      Message.error(ctiRes.msg);
    } else {
      visible.value = true;
      //判断用户是否有webrtc模式
      if (ctiRes?.data?.includes('webrtc')) {
        //获取绑定的分机号
        CtiAgentBar.getAlreadyBind()
          .then((res) => {
            var regExp = new RegExp('^\\d{6}$');
            if (regExp.test(res)) {
              ctiData.agentNo = res;
              ctiFn.login();
            } else {
              visible.value = false;
              Modal.error({
                title: '出错了',
                content: '登录电话条失败：未分配可用分机号',
                width: 350,
                style: { zIndex: 9999 }
              });
            }
          })
          .catch((e) => console.log(368394368, e));
      }
    }
  } catch (e) {
    // loading.value = false;
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};

// 获取基本信息
const open = async (params) => {
  visible.value = false;
  CtiAgentBar.destroy();
  const doms = document.querySelectorAll('.call-mky-popup');
  doms.length &&
    doms.forEach((el) => {
      el.style.display = 'none';
    });
  try {
    loading.value = true;
    const json = await publicService.getMkyOutBound(params);
    loading.value = false;
    if (!json.error) {
      const res = json.result;
      detail.value = res;
      if (!detail.value.ext || !detail.value.password) {
        Message.error('用户名或密码未配置，请联系管理员');
        visible.value = false;
        return;
      }
      initConfig.username = detail.value.ext;
      // initConfig.username = '005@shlc.com';
      initConfig.password = detail.value.password;
      //  注册
      await ctiInit(detail.value);
    } else {
      // Message.error(json.error?.msg || '获取数据失败');
    }
  } catch (e) {
    // loading.value = false;
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};
// 拨打后给后端发信息
const saveData = async () => {
  try {
    const params = {
      businessId: detail.value?.id,
      // caller: detail.value?.caller,
      source: detail.value?.ext,
      callee: detail.value?.callee?.replace('-', ''),
      type: detail.value?.type,
      orgId: detail.value?.orgId,
      userId: detail.value?.userId,
      status: status.value
    };
    await publicService.saveMkyOutBefore(params);
  } catch (e) {
    console.log(e);
    // Message.error(e.message || e.statusText || '获取数据失败');
  }
};
// 拨打
// const phoneHandle = () => {};

// 外呼
// const outCall = () => {
//   rtc.call(detail.value.callee);
//   saveData();
// };
// // 挂断
// const hangUp = () => {
//   rtc && rtc.hangup();
// };

// // 关闭弹窗
const close = () => {
  // rtc && rtc?.unregister?.();
  CtiAgentBar.destroy();
  visible.value = false;
};

// 导出
defineExpose({
  open
});

// 拖动
const handleRemove = (e) => {
  const tar = e?.target;

  const getparent = (t, clas) => {
    if (t.nodeName === 'BODY') {
      return null;
    }
    if (['svg', 'path', 'g', 'circle'].lastIndexOf(t.nodeName) > -1) {
      return getparent(t?.parentNode, clas);
    }
    if (t?.className?.indexOf(clas) > -1) {
      return t;
    } else {
      return getparent(t?.parentNode, clas);
    }
  };
  const dom = getparent(tar, 'call-mky-popup');
  if (tar?.nodeName !== 'svg' && (tar?.className?.includes?.('mky-header') || tar?.parentNode?.className?.includes?.('mky-header') || tar?.parentNode?.parentNode?.className?.includes?.('mky-header') || tar?.parentNode?.parentNode?.parentNode?.className?.includes?.('mky-header'))) {
    const disX = e.clientX - dom.offsetLeft;
    const disY = e.clientY - dom.offsetTop;
    document.onmousemove = function (e) {
      let left = e.clientX - disX;
      let top = e.clientY - disY;
      if (left < dom.offsetWidth / 2) {
        left = dom.offsetWidth / 2;
      } else if (left > window.innerWidth - dom.offsetWidth / 2) {
        left = window.innerWidth - dom.offsetWidth / 2;
      }
      if (top < dom.offsetHeight / 2) {
        top = dom.offsetHeight / 2;
      } else if (top > window.innerWidth - dom.offsetHeight / 2) {
        top = window.innerWidth - dom.offsetHeight / 2;
      }

      dom.style.left = left + 'px';
      dom.style.top = top + 'px';
    };
    document.onmouseup = function () {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }
};

// onUnmounted(() => {
//   close();
// });
</script>
<style scoped lang="less">
@import './out-call-kty.less';
</style>
